import { useTranslation } from 'next-i18next';

import { Dealer } from '../dealer.types';

const defaultOpeningHours: { [key: string]: string[] } = {
  mon: [],
  tue: [],
  wed: [],
  thu: [],
  fri: [],
  sat: [],
  sun: [],
};

const DealerOpeningHours = ({ dealer, dataTestId }: { dealer?: Dealer; dataTestId?: string }) => {
  const { t } = useTranslation(['shared']);

  if (!dealer || Object.keys(dealer.openingHours || {})?.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col" data-testid={dataTestId}>
      {Object.entries({ ...defaultOpeningHours, ...dealer?.openingHours })?.map(([day, hours]) => {
        return (
          <dl
            className="flex flex-col py-1 stihl-text-body-default-reg tablet:flex-row desktop:flex-row"
            key={`${day}-${hours || 'closed'}`}
          >
            <dt className="min-w-[120px]">{t(`shared_dealers_map_detail_label_hours_${day}`)}</dt>
            <dd
              className="max-w-fit flex-1"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: hours.length
                  ? hours.join(`&nbsp;${t('shared_dealers_map_detail_label_and')}&nbsp;`)
                  : t('shared_dealers_map_detail_label_closed_today'),
              }}
            />
          </dl>
        );
      })}
    </div>
  );
};

export { DealerOpeningHours };
